import { Route } from 'react-router-dom';
import SubscriptionPage from './pages/SubscriptionPage';
import PaymentPage from './pages/PaymentPage';

export const SubscriptionRoutes = [
  <Route key="subscription" path="/dashboard/subscription" element={<SubscriptionPage />} />,
  <Route key="payment" path="/dashboard/subscription/payment" element={<PaymentPage />} />
];